import type React from 'react';

import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

import TMXSelect, { type MuiSelectProps } from 'components/selectors/tmxSelector/TMXSelect';
import { type SuspensionPoint } from 'typedefs/store/tmxTypes';

interface TMXSuspensionPointsSelectProps {
  suspensionPoints?: SuspensionPoint[];
  initialValue?: string;
}

type SuspensionPointsSelectProps = MuiSelectProps & TMXSuspensionPointsSelectProps;

const SuspensionPointsSelect: React.FC<React.PropsWithChildren<SuspensionPointsSelectProps>> = ({
  suspensionPoints,
  initialValue,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <TMXSelect displayEmpty fullWidth defaultValue={initialValue} {...props}>
      <MenuItem disabled value="">
        {t('none')}
      </MenuItem>
      {(suspensionPoints || []).map((suspensionPoint) => (
        <MenuItem key={suspensionPoint.code} value={suspensionPoint.code}>
          {suspensionPoint.code} - {suspensionPoint.shortDescription}{' '}
          {t('players.penaltyPointsLong', { count: suspensionPoint.points })}
        </MenuItem>
      ))}
    </TMXSelect>
  );
};

export default SuspensionPointsSelect;
